<template>
  <div v-if="!item.hidden" class="collitem">
    <template
      v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow"
    >
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
        <el-menu-item
          v-if="onlyOneChild.meta.title!='企业认证管理'"
          :index="resolvePath(onlyOneChild.path)"
          :class="{'submenu-title-noDropdown':!isNest}"
        >
          <item
            :icon="onlyOneChild.meta.icon||(item.meta&&item.meta.icon)"
            :title="onlyOneChild.meta.title"
          />
        </el-menu-item>
        <el-menu-item
          v-else
          :index="resolvePath(onlyOneChild.path)"
          :class="{'submenu-title-noDropdown':!isNest}"
        >
          <i
            :class="onlyOneChild.meta.icon"
            class="sub-el-icon"
            style="margin-left:-2px;color:white;"
          />
          <template #title>{{onlyOneChild.meta.title}}</template>
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template #title>
        <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title" />
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import { path } from "path";
import { nextTick } from "vue";
import { isExternal } from "@/utils/validate";
import Item from "./Item";
import AppLink from "./Link";
import FixiOSBug from "./FixiOSBug";
export default {
  name: "SidebarItem",
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ""
    }
  },
  data() {
    this.onlyOneChild = null;
    return {};
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item;
          return true;
        }
      });
      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: "", noShowingChildren: true };
        // console.log(this.onlyOneChild)
        return true;
      }

      return false;
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      if (this.basePath == routePath) {
        return routePath;
      } else {
        return this.basePath + "/" + routePath;
      }
      // 这个地方有问题
      // return path.resolve(this.basePath, routePath)
    }
  }
};
</script>
<style lang="less">
.collitem {
  i {
    color: #8a92a6 !important;
  }
  a.router-link-active {
    i::before {
      color: white;
    }
  }
  a:hover {
    i::before {
      color: white;
    }
  }
}
.hideSidebar {
  .el-submenu:not(.is-active):hover div i::before {
    color: white;
  }
}
.openSidebar {
  .el-submenu:not(.is-active) .el-submenu__title:hover i.el-icon-grape::before {
    color: white;
  }
  .el-submenu:not(.is-active) .linkstyle:hover i.el-icon-grape::before {
    color: white;
  }
}
</style>